import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clearMatchesSuspensions } from "@/api/sportEventsNew";
import { SportEventsNewQueryKeys } from "@/tanstackQuery/queries/sportEventsNew";
import type {
  ClearMatchSuspensionsParams,
  MatchSuspensionsEditorResponse,
} from "@/types/ApiResponses/SportEvent";

export const useClearMatchesSuspensions = (
  feedType: string,
  sportType?: string,
  targetUsername?: string,
  page?: number,
  pageSize?: number,
  search?: string
) => {
  const queryClient = useQueryClient();
  // Must mirror useMatchesSuspensions' key exactly (incl. search) so the
  // optimistic clear lands on the page the user is currently viewing.
  const queryKey = [
    SportEventsNewQueryKeys.MatchSuspensions,
    feedType,
    sportType,
    targetUsername,
    page,
    pageSize,
    search,
  ];

  return useMutation({
    mutationFn: (params: ClearMatchSuspensionsParams) =>
      clearMatchesSuspensions(params),
    onMutate: async () => {
      await queryClient.cancelQueries({ queryKey, exact: true });

      const previousData =
        queryClient.getQueryData<MatchSuspensionsEditorResponse>(queryKey);

      if (previousData) {
        queryClient.setQueryData<MatchSuspensionsEditorResponse>(queryKey, {
          ...previousData,
          suspensions: {},
        });
      }

      return { previousData };
    },
    onError: (_err, _variable, context) => {
      if (context?.previousData) {
        queryClient.setQueryData(queryKey, context.previousData);
      }
    },
  });
};
